import type { ScoutDashboardMetricsQuery } from "generated-graphql/graphql";

import { Card, CardContent, Skeleton, Typography } from "@mui/material";

import { getLatestFreshValue } from "./scoutDashboardFreshness";
import { ScoutMetricDocumentationHeader } from "./ScoutDashboardMetricDocumentation";

type ScoutDashboardWidget =
  ScoutDashboardMetricsQuery["scoutDashboardMetrics"]["statWidgets"][number];

export function ScoutDashboardStatCard({
  widget,
  loading,
  periodSeconds,
}: {
  widget?: ScoutDashboardWidget;
  loading: boolean;
  periodSeconds: number;
}) {
  if (loading || !widget) {
    return (
      <Card variant="outlined" sx={{ height: "100%" }} data-testid="scout-stat-skeleton">
        <CardContent>
          <Skeleton width="60%" />
          <Skeleton width="40%" height={44} />
        </CardContent>
      </Card>
    );
  }

  const value = getLatestFreshValue(widget, periodSeconds);

  return (
    <Card variant="outlined" sx={{ height: "100%" }}>
      <CardContent>
        <ScoutMetricDocumentationHeader widget={widget} titleVariant="body2" />
        <Typography variant="h4" sx={{ mt: 1, fontWeight: 600 }}>
          {value === null ? "--" : value}
        </Typography>
      </CardContent>
    </Card>
  );
}
